import { useState, useEffect } from 'react'
import {
  LayoutDashboard,
  Users,
  Shield,
  Banknote,
  Coins,
  BookCheck
} from 'lucide-react'
import { NavLink } from 'react-router-dom'
import { colors } from '../../Constant/Color'
import { hasPermission } from '../../utils'

function BottomNav() {
  const [activePath, setActivePath] = useState(window.location.pathname)

  // Bottom navigation menu items (main items only)
  const menuItems = [
    {
      icon: LayoutDashboard,
      label: 'Dashboard',
      path: '/',
      module: 'dashboard',
    },
    {
      icon: Shield,
      label: 'Roles',
      path: '/role',
      module: 'rolesAndPermissions',
    },
    {
      icon: Banknote,
      label: 'Accounts',
      path: '/account',
      module: 'account',
    },
    {
      icon: BookCheck,
      label: 'Books',
      path: '/book',
      module: 'book',
    },
    {
      icon: Users,
      label: 'Users',
      path: '/users',
      module: 'user',
    },
    {
      icon: Coins,
      label: 'Cashbook',
      path: '/cashbook',
      module: 'cashbook',
    },
  ]

  // Filter menu items based on permissions
  const visibleMenuItems = menuItems.filter(item => {
    if (!item.module) return true;
    return hasPermission(item.module, 'read');
  });

  // Update active path on location change
  useEffect(() => {
    const handleLocationChange = () => {
      setActivePath(window.location.pathname)
    }
    window.addEventListener('popstate', handleLocationChange)
    return () => window.removeEventListener('popstate', handleLocationChange)
  }, [])

  const isActive = (path) => {
    // Check if current path starts with the menu item path
    if (path === '/') {
      return activePath === '/'
    }
    return activePath.startsWith(path)
  }

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50"
      style={{
        paddingBottom: 'env(safe-area-inset-bottom)',
        boxShadow: '0 -2px 10px rgba(0, 0, 0, 0.1)'
      }}
    >
      <div className="flex items-center justify-around h-16 max-w-screen-sm mx-auto">
        {visibleMenuItems.map((item, index) => {
          const Icon = item.icon
          const itemIsActive = isActive(item.path)

          return (
            <NavLink
              key={index}
              to={item.path}
              onClick={() => setActivePath(item.path)}
              className="flex flex-col items-center justify-center flex-1 h-full gap-1 transition-all duration-200 active:scale-95"
            >
              <div
                className={`p-2 rounded-xl transition-all duration-200 ${
                  itemIsActive ? 'scale-110' : ''
                }`}
                style={{
                  backgroundColor: itemIsActive ? colors.PRIMARY_LIGHTER : 'transparent',
                }}
              >
                <Icon
                  className={`w-5 h-5 transition-colors duration-200`}
                  style={{
                    color: itemIsActive ? colors.PRIMARY : colors.TEXT_SECONDARY,
                    strokeWidth: itemIsActive ? 2.5 : 2
                  }}
                />
              </div>
              <span
                className="text-xs font-medium transition-colors duration-200"
                style={{
                  color: itemIsActive ? colors.PRIMARY : colors.TEXT_SECONDARY,
                  fontWeight: itemIsActive ? '600' : '500'
                }}
              >
                {item.label}
              </span>
            </NavLink>
          )
        })}
      </div>
    </nav>
  )
}

export default BottomNav
